import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Clock, Mic, ArrowRight } from 'lucide-react';

export default function WaitingApproval() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-8">
      <Card className="max-w-md w-full border-0 shadow-xl">
        <CardContent className="pt-12 pb-8 px-8 text-center">
          <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <Clock className="w-10 h-10 text-amber-600" />
          </div>
          
          <h1 className="text-2xl font-bold mb-3" data-testid="waiting-title">
            Aguardando Aprovação
          </h1>
          
          <p className="text-muted-foreground mb-8 leading-relaxed">
            Seu cadastro foi realizado com sucesso! Agora é só aguardar o administrador 
            aprovar sua conta. Você receberá acesso assim que for liberado.
          </p>
          
          <div className="bg-muted rounded-2xl p-6 mb-8">
            <div className="flex items-center gap-3 text-left">
              <div className="w-10 h-10 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0">
                <Mic className="w-5 h-5 text-primary" />
              </div>
              <div>
                <p className="font-medium text-sm">Enquanto aguarda...</p>
                <p className="text-xs text-muted-foreground">
                  Prepare suas ideias! Em breve você poderá gravá-las por voz.
                </p>
              </div>
            </div>
          </div>
          
          <div className="space-y-3">
            <Link to="/pagamento" data-testid="payment-link">
              <Button className="w-full h-11 rounded-full font-medium">
                Realizar Pagamento
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
            
            <Link to="/login" data-testid="back-to-login">
              <Button variant="ghost" className="w-full">
                Voltar ao Login
              </Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
